import type { FC } from 'react';
import { Flex } from '@ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AirportDetailed } from '@/components/AirportDetailed/AirportDetailed';
import { AirportsList } from '@/components/AirportsList/AirportsList';
import { GenericPageSectionWrapper } from '@/components/GenericPageSectionWrapper/GenericPageSectionWrapper';
import { useAirportsActivity } from '@/queries/useAirportsActivity';
import styles from './AirportsSection.module.css';

export const AirportsSection: FC = () => {
    const [selectedAirport, setSelectedAirport] = useState(1);
    const { data: airports } = useAirportsActivity();
    const { t } = useTranslation();

    if (!airports.length) {
        return null;
    }

    return (
        <GenericPageSectionWrapper title={t('Airports_Title')} size="l">
            <Flex gap={80} className={styles.innerWrapper}>
                <AirportsList
                    airports={airports}
                    value={selectedAirport}
                    onChange={setSelectedAirport}
                />
                <AirportDetailed airportId={selectedAirport} />
            </Flex>
        </GenericPageSectionWrapper>
    );
};
